var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6477 4075.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#415b91;}.cls-2,.cls-3{fill:#b6d0fb;}.cls-4{fill:#fff;}.cls-5{fill:#6cdd6c;}.cls-3{fill-rule:evenodd;}.cls-6{fill:#50aa50;}.cls-7{fill:#3f5b91;}.cls-8{fill:#405b91;}.cls-9{fill:#d7e7ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M4332.78,3928.55c-8.73-28.52-28.71-55.22-57.1-64.36-28.39-9.14-64.41,4.7-73.25,33.19-26.12-21.81-66.15-4.49-87.14,22.3-33.94,43.31-7.71,114.25-2.05,118.86,6.12,4.97,22.7,4.1,22.7,4.1l254.01-1.41s46.6-3.4,68.1-11.97c43.28-17.26,72.7-91.72,44.86-129.07-18.98-25.46-56.45-30.86-86.7-21.2-30.25,9.66-59.6,28.58-83.43,49.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M4132.32,4051.11c-6.44,0-17.92-.84-24.37-6.08-9.96-8.09-35.27-84.59.74-130.53,15.17-19.34,37.89-32.78,59.33-35.04,11.19-1.28,21.62.69,30.71,5.42,5.46-9.8,14.09-18.02,25.06-23.72,16.71-8.68,37.07-10.57,54.46-4.95,25.26,8.12,46.44,29.45,58.33,58.15,24.73-20.05,51.74-35.28,77.07-43.37,30.33-9.7,73.3-6.24,95.99,24.18,13.06,17.53,16.09,43.42,8.27,71.06-9.32,32.99-31.6,60.79-56.74,70.81-22.46,8.96-68.65,12.4-70.61,12.55l-254.56,1.42c-.84.05-2.1.1-3.67.1ZM4174.52,3895.87c-1.54,0-3.13.08-4.75.26-16.81,1.77-35.61,13.06-47.88,28.71-29.79,38.02-7.54,101.46-2.67,107.85,1.13.82,9.52,1.95,16.28,1.56l254.4-1.42c-.11-.02,45-3.37,65.04-11.38,20.18-8.03,38.98-32.06,46.81-59.77,6.39-22.57,4.36-43.16-5.57-56.48-17.76-23.85-52.61-26.16-77.43-18.21-26.4,8.44-54.97,25.44-80.44,47.86-2.13,1.9-5.08,2.56-7.81,1.79-2.75-.79-4.92-2.9-5.75-5.62-8.96-29.32-28.27-51.3-51.65-58.84-13.19-4.24-28.76-2.8-41.59,3.88-10.53,5.47-18.02,13.92-21.08,23.82-.83,2.67-2.95,4.75-5.63,5.55-2.67.79-5.58.2-7.75-1.61-6.32-5.27-13.89-7.94-22.54-7.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M4065.66,3918.93c-7.27,14.15-10.39,29.5-8.66,45.35.87,7.96,13.46,8.05,12.58,0-1.49-13.68.64-26.73,6.94-39,3.69-7.19-7.16-13.56-10.86-6.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M4028.96,3929.02c-3.96,14.22-4.25,28.44-1.09,42.85,1.73,7.9,13.86,4.56,12.13-3.34-2.68-12.21-2.25-24.13,1.09-36.16,2.17-7.81-9.96-11.15-12.13-3.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M4099.52,3903.49c8.09,0,8.11-12.58,0-12.58s-8.11,12.58,0,12.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M4135.16,3964.29v11.18c0,8.09,12.58,8.11,12.58,0v-11.18c0-8.09-12.58-8.11-12.58,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M4347.62,3983.86v5.59c0,8.09,12.58,8.11,12.58,0v-5.59c0-8.09-12.58-8.11-12.58,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M4324.31,3968.74c.93.93,1.86,1.86,2.79,2.79,5.73,5.73,14.63-3.16,8.9-8.9l-2.79-2.79c-5.73-5.73-14.63,3.16-8.9,8.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M749.69,3691.45h-425.83c-9.26,0-16.77-7.5-16.77-16.77s7.51-16.77,16.77-16.77h425.83c9.26,0,16.77,7.5,16.77,16.77s-7.51,16.77-16.77,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4499.38,2214.61h-12.16c0-10.06-8.18-18.24-18.24-18.24s-18.24,8.19-18.24,18.24h-12.17c0-16.77,13.64-30.41,30.4-30.41s30.4,13.64,30.4,30.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4542.88,1506.45h-12.16c0-10.06-8.18-18.24-18.24-18.24s-18.24,8.19-18.24,18.24h-12.16c0-16.77,13.64-30.41,30.41-30.41s30.4,13.64,30.4,30.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3028.94,3967.27h-578.77l9.82-23.29c37.95-90.02,41.87-167.11,36.09-255.17l-1.16-17.82,487.97-1.49.12,16.69c.42,56.92,15.81,186.19,38.99,259.23l6.94,21.85ZM2500.13,3933.73h483.59c-18.62-70.4-31.29-172.15-33.8-230.58l-419.31,1.29c3.97,78.08-.8,149.12-30.48,229.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2283.77,3702.83c-439.41,0-795.35-2.4-810.98-7.98-37.61-13.4-86.76-65.52-87.43-102.5-1.42-80.06-4.86-189.09-8.85-315.37-12.04-380.68-28.51-902.04-7.14-1190.55,3.9-52.57,47.32-93.18,99.22-93.18h1.67l2533.26,3.77c53.58.92,96.54,44.16,97.79,98.44,1.94,84.27,4.68,170.39,7.44,257.69,11.6,365.48,23.58,743.43-16.89,1100.82-1.59,14.09-2.29,29.65-3.02,45.77-3.42,74.98-7.66,168.31-104.31,187.38-47.25,9.32-984.78,15.7-1700.77,15.7ZM1468.81,2020.23c-38.03,0-69.68,29.73-72.54,68.21-21.27,287.08-4.82,807.63,7.19,1187.7,4,126.36,7.45,235.49,8.88,315.74.42,23.33,39.41,66.84,69.52,77.59,53.94,11.01,2435.56,2.87,2497.47-8.77,75.89-14.99,79.3-89.8,82.59-162.17.76-16.75,1.52-32.92,3.16-47.59,40.27-355.42,28.3-732.39,16.74-1096.92-2.76-87.36-5.5-173.55-7.45-257.9-.91-39.74-32.18-71.4-71.2-72.11l-2533.14-3.77h-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3932.67,2084.23l-2386.81-3.14c-42.93-.64-78.97,28.79-82.19,67.26-26.74,319.46,9.71,986,15.1,1254.25.53,26.14,43.2,65.35,73.94,75.06,36.18,11.43,2304.4,2.8,2359.83-6.89,99.56-17.38,82.61-119.33,90.96-184.58,47.24-368.96,18.22-770.01,8.82-1130.88-1.02-39.08-36.17-70.42-79.66-71.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3236,4059.1h-993.11c-39.41,0-60.03-31-60.03-61.62s20.62-61.7,60.03-61.7h993.11c39.41,0,60.03,31,60.03,61.62s-20.62,61.7-60.03,61.7ZM2242.89,3962.74c-26.1,0-33.06,21.83-33.06,34.74s6.97,34.65,33.06,34.65h993.11c26.1,0,33.06-21.83,33.06-34.74s-6.97-34.66-33.06-34.66h-993.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1551.26,3608.86c44.6,0,44.67-69.31,0-69.31s-44.67,69.31,0,69.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1691,3608.86c44.6,0,44.67-69.31,0-69.31s-44.67,69.31,0,69.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1830.74,3608.86c44.6,0,44.68-69.31,0-69.31s-44.67,69.31,0,69.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2739.44,2063.62c20.92,0,20.96-32.51,0-32.51s-20.95,32.51,0,32.51h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5540.25 3993.23 5198.04 3993.23 5329.66 3560.94 5408.63 3560.94 5540.25 3993.23"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5169.77,
    y: 3993.23,
    width: 398.75,
    height: 49.39
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5230.95 3885.16 5198.04 3993.23 5540.25 3993.23 5507.34 3885.16 5230.95 3885.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5263.85 3777.09 5474.44 3777.09 5441.53 3669.02 5296.76 3669.02 5263.85 3777.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5680.18,4039.83h75.93v-294.01h389.78v294.01h75.93v-294.01h80.41v-234.76h-64.14v-21.69h-110.64v21.69h-345.31v-21.69h-110.64v21.69h-70.42v234.76h79.09v294.01ZM6277.72,3535.57v.98l-46.8,184.73h-83.53l47.05-185.72h83.28ZM6059.9,3721.29h-83.53l47.05-185.72h83.53l-47.05,185.72ZM5888.87,3721.29h-83.53l47.05-185.72h83.52l-47.05,185.72ZM5681.36,3535.57h83.52l-47.05,185.72h-83.52l47.05-185.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1945.36,1165.66l22.74-22.76c4.64-4.6,4.64-12.08,0-16.7l-19.82-19.78c-4.56-4.62-5.78-13.01-2.64-18.69l16.15-39.21c1.82-6.28,8.67-11.38,15.15-11.38h28.04c6.52,0,11.81-5.3,11.81-11.74v-32.26c0-6.53-5.29-11.77-11.81-11.77h-28.04c-6.49,0-13.34-5.1-15.15-11.35l-16.15-39.18c-3.14-5.72-1.92-14.12,2.64-18.75l19.82-19.78c4.64-4.62,4.64-12.11,0-16.65l-22.74-22.84c-4.61-4.6-12.11-4.6-16.68,0l-19.84,19.81c-4.61,4.59-13,5.8-18.67,2.72l-39.25-16.17c-6.23-1.85-11.32-8.63-11.32-15.16v-28.05c0-6.47-5.29-11.82-11.79-11.82h-32.19c-6.52,0-11.82,5.35-11.82,11.82v28.05c0,6.53-5.09,13.31-11.32,15.16l-39.25,16.17c-5.68,3.08-14.1,1.88-18.67-2.72l-19.86-19.78c-4.57-4.63-12.06-4.63-16.62,0l-22.83,22.81c-4.61,4.54-4.61,12.02,0,16.65l19.81,19.78c4.6,4.62,5.81,13.03,2.69,18.75l-16.15,39.18c-1.83,6.25-8.68,11.35-15.15,11.35h-28.08c-6.47,0-11.79,5.24-11.79,11.77v32.26c0,6.45,5.31,11.74,11.79,11.74h28.08c6.47,0,13.33,5.1,15.15,11.38l16.15,39.21c3.12,5.72,1.91,14.07-2.69,18.69l-19.81,19.78c-4.61,4.62-4.61,12.11,0,16.7l22.83,22.76c4.56,4.65,12.05,4.65,16.62,0l19.86-19.78c4.57-4.59,13-5.8,18.7-2.66l39.21,16.14c6.24,1.79,11.32,8.63,11.32,15.13v28.11c0,6.45,5.3,11.77,11.82,11.77h32.19c6.5,0,11.79-5.32,11.79-11.77v-28.11c0-6.5,5.09-13.34,11.32-15.13l39.25-16.14c5.68-3.14,14.06-1.93,18.67,2.66l19.84,19.78c4.57,4.65,12.07,4.65,16.68,0ZM1811.71,1103.37c-51.99,0-94.13-42.18-94.13-94.11s42.14-94.1,94.13-94.1,94.11,42.12,94.11,94.1-42.14,94.11-94.11,94.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2162.99,1254.61l-5.75-19.11c-1.18-3.87-5.27-6.06-9.13-4.91l-16.59,5.04c-3.87,1.18-8.85-.64-11.04-4.06l-16.71-20.26c-2.82-2.8-3.63-8.04-1.72-11.6l8.19-15.3c1.92-3.59.56-8.02-2.94-9.92l-17.61-9.42c-3.54-1.93-7.98-.53-9.89,3l-8.23,15.3c-1.88,3.53-6.68,5.77-10.6,4.96l-26.17-2.63c-3.99.03-8.28-3.05-9.41-6.95l-5.06-16.62c-1.15-3.84-5.23-6.05-9.09-4.85l-19.12,5.72c-3.92,1.2-6.03,5.27-4.89,9.16l5.06,16.59c1.18,3.89-.66,8.8-4.09,11.01l-20.29,16.73c-2.77,2.86-8.03,3.59-11.57,1.71l-15.33-8.21c-3.51-1.91-7.98-.59-9.86,3l-9.46,17.54c-1.86,3.59-.56,8.04,2.98,9.92l15.33,8.27c3.57,1.88,5.79,6.64,4.97,10.57l-2.61,26.15c0,4.04-3.09,8.32-6.96,9.42l-16.63,5.07c-3.88,1.15-6.08,5.27-4.89,9.11l5.78,19.08c1.14,3.89,5.25,6.05,9.14,4.88l16.62-5.02c3.83-1.15,8.76.7,10.96,4.03l16.72,20.32c2.84,2.8,3.62,8.04,1.74,11.6l-8.22,15.3c-1.87,3.53-.54,7.96,3.02,9.92l17.56,9.39c3.55,1.91,8,.56,9.91-2.97l8.24-15.33c1.86-3.59,6.68-5.77,10.59-4.99l26.12,2.66c4.08,0,8.31,3.08,9.46,6.98l5.01,16.59c1.18,3.87,5.3,6.08,9.13,4.88l19.1-5.77c3.84-1.15,6.04-5.27,4.93-9.08l-5.04-16.62c-1.19-3.84.61-8.85,3.98-11.01l20.31-16.7c2.8-2.86,8.07-3.64,11.61-1.77l15.3,8.21c3.57,1.96,8.06.59,9.93-2.97l9.42-17.6c1.92-3.5.53-7.99-3.02-9.89l-15.32-8.24c-3.55-1.93-5.79-6.64-4.94-10.54l2.65-26.23c-.04-3.98,3.1-8.27,6.93-9.42l16.64-5.02c3.83-1.18,6.02-5.24,4.84-9.11ZM2089.87,1309.34c-15.2,28.42-50.62,39.09-78.94,23.88-28.4-15.22-39.08-50.58-23.88-78.92,15.21-28.47,50.63-39.12,78.99-23.9,28.33,15.25,39.04,50.58,23.84,78.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3115.4,1623.03h-527.25c-9.26,0-16.77-7.51-16.77-16.77s7.51-16.77,16.77-16.77h527.25c9.26,0,16.77,7.51,16.77,16.77s-7.51,16.77-16.77,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2042.01,1862.55h-851.65c-9.26,0-16.77-7.51-16.77-16.77s7.51-16.77,16.77-16.77h851.65c9.26,0,16.77,7.51,16.77,16.77s-7.51,16.77-16.77,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M6125.42,2316.04h-851.64c-9.27,0-16.77-7.51-16.77-16.77s7.5-16.77,16.77-16.77h851.64c9.27,0,16.77,7.51,16.77,16.77s-7.5,16.77-16.77,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M6460.23,4075.87H16.77c-9.26,0-16.77-7.5-16.77-16.77s7.51-16.77,16.77-16.77h6443.46c9.27,0,16.77,7.5,16.77,16.77s-7.5,16.77-16.77,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4096.69,1412.37c-36.12,0-70.09,14.07-95.63,39.62-43.57,43.56-52.22,111.06-21.06,164.13l2.22,3.76-136.96,136.95c-.18.19-6.64,6.46-6.74,15.57-.06,6.87,3.41,13.88,10.34,20.8,7.36,7.34,15.07,11.08,22.89,11.08,9.41,0,16.06-5.45,16.12-5.48l136.61-136.68,3.79,2.24c20.67,12.14,44.35,18.55,68.47,18.55,36.13,0,70.08-14.05,95.63-39.59,52.73-52.76,52.73-138.56,0-191.32-25.55-25.55-59.53-39.62-95.67-39.62ZM4096.69,1642.75c-52.42,0-95.09-42.66-95.1-95.09,0-52.44,42.69-95.13,95.13-95.13h0c52.44,0,95.11,42.67,95.11,95.13s-42.68,95.09-95.14,95.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4046.55,1567.44h97.96v-25.07h-97.96v25.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1584.75,4044.8c-9.26,0-16.77-7.5-16.77-16.77v-1291.82c0-9.26,7.51-16.77,16.77-16.77s16.77,7.51,16.77,16.77v1291.82c0,9.27-7.51,16.77-16.77,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1884.95,4044.8c-9.26,0-16.77-7.5-16.77-16.77v-1291.82c0-9.26,7.51-16.77,16.77-16.77s16.77,7.51,16.77,16.77v1291.82c0,9.27-7.51,16.77-16.77,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1884.95,2841.26h-300.2c-9.26,0-16.77-7.51-16.77-16.77s7.51-16.77,16.77-16.77h300.2c9.26,0,16.77,7.51,16.77,16.77s-7.51,16.77-16.77,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1884.95,2988.85h-300.2c-9.26,0-16.77-7.5-16.77-16.77s7.51-16.77,16.77-16.77h300.2c9.26,0,16.77,7.5,16.77,16.77s-7.51,16.77-16.77,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1884.95,3136.43h-300.2c-9.26,0-16.77-7.5-16.77-16.77s7.51-16.77,16.77-16.77h300.2c9.26,0,16.77,7.5,16.77,16.77s-7.51,16.77-16.77,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1884.95,3284.01h-300.2c-9.26,0-16.77-7.5-16.77-16.77s7.51-16.77,16.77-16.77h300.2c9.26,0,16.77,7.5,16.77,16.77s-7.51,16.77-16.77,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1884.95,3431.6h-300.2c-9.26,0-16.77-7.5-16.77-16.77s7.51-16.77,16.77-16.77h300.2c9.26,0,16.77,7.5,16.77,16.77s-7.51,16.77-16.77,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1884.95,3579.18h-300.2c-9.26,0-16.77-7.5-16.77-16.77s7.51-16.77,16.77-16.77h300.2c9.26,0,16.77,7.5,16.77,16.77s-7.51,16.77-16.77,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1884.95,3726.77h-300.2c-9.26,0-16.77-7.5-16.77-16.77s7.51-16.77,16.77-16.77h300.2c9.26,0,16.77,7.5,16.77,16.77s-7.51,16.77-16.77,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1884.95,3874.33h-300.2c-9.26,0-16.77-7.5-16.77-16.77s7.51-16.77,16.77-16.77h300.2c9.26,0,16.77,7.5,16.77,16.77s-7.51,16.77-16.77,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1175.89,2798.87c-9.26,0-16.77-7.51-16.77-16.77v-65.31c0-9.26,7.51-16.77,16.77-16.77s16.77,7.51,16.77,16.77v65.31c0,9.26-7.51,16.77-16.77,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1208.55,2766.22h-65.3c-9.26,0-16.77-7.51-16.77-16.77s7.51-16.77,16.77-16.77h65.3c9.26,0,16.77,7.51,16.77,16.77s-7.51,16.77-16.77,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2684.34,462.84c-9.26,0-16.77-7.51-16.77-16.77v-65.31c0-9.26,7.51-16.77,16.77-16.77s16.77,7.51,16.77,16.77v65.31c0,9.26-7.51,16.77-16.77,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2716.99,430.19h-65.3c-9.26,0-16.77-7.51-16.77-16.77s7.51-16.77,16.77-16.77h65.3c9.26,0,16.77,7.51,16.77,16.77s-7.51,16.77-16.77,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3213.1,3844.14c-1.52,0-3.07-.21-4.61-.64l-62.79-17.92c-8.91-2.56-14.07-11.83-11.52-20.74,2.54-8.91,11.85-13.97,20.73-11.53l62.79,17.92c8.91,2.56,14.07,11.83,11.52,20.74-2.1,7.37-8.82,12.17-16.12,12.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3172.74,3866.58c-1.52,0-3.07-.21-4.61-.64-8.91-2.56-14.07-11.83-11.52-20.74l17.94-62.8c2.55-8.91,11.84-13.97,20.73-11.53,8.91,2.56,14.07,11.83,11.52,20.74l-17.94,62.8c-2.11,7.37-8.82,12.17-16.12,12.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2883.18,1871.53c-1.52,0-3.07-.21-4.61-.66l-62.79-17.94c-8.91-2.54-14.07-11.83-11.52-20.73,2.55-8.91,11.8-14.07,20.73-11.52l62.8,17.94c8.9,2.54,14.06,11.83,11.52,20.73-2.1,7.37-8.82,12.18-16.12,12.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2842.82,1893.95c-1.52,0-3.07-.21-4.61-.66-8.91-2.54-14.07-11.83-11.52-20.73l17.93-62.79c2.55-8.91,11.8-14.07,20.73-11.52,8.91,2.54,14.07,11.83,11.52,20.73l-17.93,62.79c-2.1,7.37-8.82,12.18-16.12,12.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 2839.18,
    cy: 1253.37,
    r: 233.01,
    transform: "translate(-54.69 2374.71) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 2839.18,
    cy: 1253.37,
    r: 174.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2839.18,1434.68c-99.97,0-181.31-81.33-181.31-181.3s81.33-181.31,181.31-181.31,181.31,81.33,181.31,181.31-81.33,181.3-181.31,181.3ZM2839.18,1085.57c-92.52,0-167.8,75.28-167.8,167.8s75.27,167.8,167.8,167.8,167.8-75.27,167.8-167.8-75.27-167.8-167.8-167.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2839.18,1260.13c-3.73,0-6.75-3.02-6.75-6.75v-88.87c0-3.73,3.02-6.75,6.75-6.75s6.75,3.02,6.75,6.75v88.87c0,3.73-3.02,6.75-6.75,6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2943.31,1260.13h-104.12c-3.73,0-6.75-3.02-6.75-6.75s3.02-6.75,6.75-6.75h104.12c3.73,0,6.76,3.02,6.76,6.75s-3.02,6.75-6.76,6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2846.08,1098.53c0,3.81-3.09,6.89-6.89,6.89s-6.89-3.09-6.89-6.89,3.08-6.89,6.89-6.89,6.89,3.09,6.89,6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2953.55,1148.76c-2.69,2.69-7.05,2.69-9.75,0-2.69-2.69-2.69-7.06,0-9.75,2.69-2.69,7.06-2.69,9.75,0,2.69,2.69,2.69,7.06,0,9.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2994.03,1260.27c-3.81,0-6.89-3.09-6.89-6.89s3.09-6.89,6.89-6.89,6.89,3.09,6.89,6.89-3.09,6.89-6.89,6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2943.8,1367.74c-2.69-2.69-2.69-7.05,0-9.75,2.69-2.69,7.06-2.69,9.75,0,2.69,2.69,2.69,7.05,0,9.75-2.69,2.69-7.05,2.69-9.75,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2832.29,1408.22c0-3.81,3.08-6.89,6.89-6.89s6.89,3.08,6.89,6.89-3.09,6.89-6.89,6.89-6.89-3.09-6.89-6.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2724.82,1357.99c2.69-2.69,7.05-2.69,9.75,0,2.69,2.69,2.69,7.05,0,9.75-2.69,2.69-7.06,2.69-9.75,0-2.69-2.69-2.69-7.05,0-9.75Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 2684.34,
    cy: 1253.37,
    r: 6.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2734.57,1139.01c2.69,2.69,2.69,7.06,0,9.75-2.69,2.69-7.06,2.69-9.75,0s-2.69-7.06,0-9.75,7.05-2.69,9.75,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3180.04,1164.39h-97.84c-3.73,0-6.75-3.02-6.75-6.75s3.02-6.75,6.75-6.75h97.84c3.73,0,6.75,3.02,6.75,6.75s-3.02,6.75-6.75,6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3180.04,1355.86h-97.84c-3.73,0-6.75-3.02-6.75-6.75s3.02-6.75,6.75-6.75h97.84c3.73,0,6.75,3.02,6.75,6.75s-3.02,6.75-6.75,6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3301.66,1260.16h-182.75c-3.73,0-6.75-3.02-6.75-6.75s3.02-6.75,6.75-6.75h182.75c3.73,0,6.75,3.02,6.75,6.75s-3.02,6.75-6.75,6.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 3512.46,
    y: 3777.09,
    width: 108.07,
    height: 108.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3628.92,3893.55h-124.85v-124.85h124.85v124.85ZM3520.84,3876.77h91.3v-91.3h-91.3v91.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3757.31,3800.84h-97.84c-3.73,0-6.75-3.02-6.75-6.75s3.02-6.75,6.75-6.75h97.84c3.73,0,6.75,3.02,6.75,6.75s-3.02,6.75-6.75,6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3794.07,3874.9h-132.22c-5.04,0-9.13-3.02-9.13-6.75s4.08-6.75,9.13-6.75h132.22c5.04,0,9.13,3.02,9.13,6.75s-4.08,6.75-9.13,6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3842.22,3835.79h-182.75c-3.73,0-6.75-3.02-6.75-6.75s3.02-6.75,6.75-6.75h182.75c3.73,0,6.75,3.02,6.75,6.75s-3.02,6.75-6.75,6.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1139.43,
    y: 2191.2,
    width: 108.07,
    height: 108.07,
    transform: "translate(2386.93 4490.46) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1255.89,2307.65h-124.84v-124.84h124.84v124.84ZM1147.82,2290.88h91.29v-91.29h-91.29v91.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1002.65,2214.95h97.84c3.73,0,6.75-3.02,6.75-6.75s-3.02-6.75-6.75-6.75h-97.84c-3.73,0-6.75,3.02-6.75,6.75s3.02,6.75,6.75,6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M965.89,2289.01h132.22c5.04,0,9.13-3.02,9.13-6.75s-4.08-6.75-9.13-6.75h-132.22c-5.04,0-9.13,3.02-9.13,6.75s4.08,6.75,9.13,6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M917.74,2249.9h182.75c3.73,0,6.75-3.02,6.75-6.75s-3.02-6.75-6.75-6.75h-182.75c-3.73,0-6.75,3.02-6.75,6.75s3.02,6.75,6.75,6.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 4435.44,
    y: 2597.28,
    width: 33.55,
    height: 1442.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4349,
    y: 2439.51,
    width: 206.41,
    height: 332.32,
    rx: 99.52,
    ry: 99.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M4587.29,2675.31c11.8,1.9,23.6,3.79,35.4,5.69,7.92,1.27,11.33-10.85,3.34-12.13-11.8-1.9-23.6-3.79-35.4-5.69-7.92-1.27-11.33,10.85-3.34,12.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M4586.08,2598.43c9.25-1.64,18.46-1.85,27.8-.96,8.05.76,8-11.82,0-12.58-10.51-1-20.76-.42-31.15,1.41-7.96,1.41-4.59,13.53,3.34,12.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M4582.23,2528.41c9.05-3.59,18.09-7.18,27.14-10.77,7.44-2.95,4.19-15.12-3.34-12.13-9.05,3.59-18.09,7.18-27.14,10.77-7.44,2.95-4.19,15.12,3.34,12.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M4273.79,2687.01c9.29-1.28,18.28-3.43,27.15-6.47,7.61-2.61,4.34-14.77-3.34-12.13-8.87,3.04-17.86,5.18-27.15,6.47-7.98,1.1-4.59,13.23,3.34,12.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M4257.46,2597.6c11.66.32,22.91,2.06,34.13,5.22,7.81,2.2,11.14-9.94,3.34-12.13-12.26-3.45-24.75-5.32-37.48-5.67-8.1-.22-8.09,12.36,0,12.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M4268.44,2494.11c9.06,2.89,18.11,5.77,27.17,8.66,7.73,2.46,11.04-9.68,3.34-12.13-9.06-2.89-18.11-5.78-27.17-8.66-7.73-2.46-11.04,9.68-3.34,12.13h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "4373.93 4059.39 4396.3 3866.58 4505.32 3866.58 4530.48 4056.6 4373.93 4059.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1295.56,3136.29c-4.96-30.66-26.67-109.77-74.44-84.72-77.31,40.53,15.94,194.4-77.21,221.53-4.99-61.34-18.16-103.59-45.86-101.08-57.11,5.18-41.93,138.04-42.87,167.94-.93,29.78-2.41,60.3-3.76,91.13-67.2,12.05-53.93-163.23-94.79-187.46-63.55-37.7-77.05,46.3-75.31,85.11,2.97,66.02,20.73,145.02,82.75,180.08,20.46,11.57,56.5,24.62,84.57,22.26-.3,52.8,1.97,105.28,10.69,155.37.09.54.98.54,1.08,0,0-.04,0-.08.02-.12l37.64,2.03c0,.23-.02.46-.03.69-.35,16.56,25.51,16.58,25.74,0,.45-31.87,20.03-188.3,22.37-320.87,30.07,4.48,67.86-9.5,89.51-25.38,64.16-47.07,71.67-133.65,59.89-206.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1110.7,3708.64c-3.81,0-7.59-.98-10.86-2.94-4.04-2.44-6.84-6.12-8.14-10.53l-27.75-1.49-10.11.33-1.55-6.34c-7.41-42.53-10.86-90.1-10.81-149.14-30.9-.03-64.78-14.35-80.93-23.47-66.15-37.41-83.48-121.8-86.37-185.99-1.16-25.82,4.28-79.24,33.19-96.57,14.66-8.79,32.47-7.11,52.89,5.01,19.76,11.71,27.29,47.7,36.01,89.36,11.8,56.42,22.41,97.05,48.29,97.67l.61-13.85c1.08-23.95,2.15-47.69,2.86-70.94.15-4.56-.1-11.57-.4-20.18-1.8-52.3-5.16-149.67,49.76-154.65,8.48-.81,16.21,1.69,22.92,7.35,15.32,12.9,25.12,42.7,29.86,90.97,34.7-15.48,32.91-55.69,30.86-101.76-2.07-46.57-4.21-94.75,36.76-116.22,13.3-6.96,26-7.53,37.72-1.64,34.14,17.08,45.86,83.97,47.09,91.54h0c9.04,55.89,12.9,157.94-62.72,213.42-21.08,15.46-56.6,29.06-86.75,27.47-1.95,86.56-10.82,181.91-16.75,245.62-2.97,31.93-5.32,57.14-5.46,67.5-.11,7.29-3.68,13.41-9.82,16.83-3.19,1.77-6.81,2.65-10.41,2.65ZM1065.4,3679.45l40.02,2.16-.2,6.96c-.09,3.32,1.1,4.35,2,4.89,1.97,1.17,4.89,1.2,6.97.03,1.65-.91,2.44-2.36,2.47-4.53.15-10.92,2.41-35.12,5.53-68.62,6.09-65.41,15.29-164.24,16.84-252.28l.15-8.13,8.05,1.2c27.75,4.13,64.12-9.33,84.23-24.08,69.5-50.98,65.59-146.95,57.07-199.61h0c-3.73-23.09-16.77-69.75-39.38-81.05-7.49-3.77-15.58-3.26-24.71,1.51-32.93,17.28-31.08,58.9-29.12,102.96,2.16,48.45,4.6,103.38-49.41,119.12l-8.4,2.44-.71-8.73c-4.96-61.13-16.69-82.95-25.66-90.48-3.79-3.19-7.74-4.49-12.44-4.06-41.48,3.75-38.31,95.74-36.78,139.94.31,8.99.56,16.34.41,21.11-.73,23.31-1.8,47.11-2.88,71.14l-1.14,25.79-5.62,1c-46,8.23-58.94-53.68-70.37-108.34-7.36-35.15-14.97-71.5-29.32-80.02-15.57-9.22-28.45-10.93-38.27-5.03-21.3,12.77-27.41,58.12-26.26,83.69,2.73,60.6,18.66,140.01,79.13,174.2,20.87,11.78,54.98,23.44,80.46,21.36l7.78-.66-.04,7.81c-.33,58.94,2.73,106.28,9.61,148.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1221.59,4042.92h-273.06c-14.56,0-26.2-9.52-28.95-23.69l-61.99-318.25,25.73-5.03,62,318.26c.48,2.5,2.55,2.5,3.22,2.5h273.06c.68,0,2.75,0,3.23-2.48l61.5-318.26,25.73,4.96-61.5,318.29c-2.73,14.18-14.38,23.7-28.96,23.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M860.37,3598.56h453.23c7.72,0,14.05,8.54,14.05,19v68.9c0,10.46-6.32,19-14.05,19h-453.23c-7.72,0-14.04-8.54-14.04-19v-68.9c0-10.46,6.32-19,14.04-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1313.6,3712.59h-453.23c-11.68,0-21.18-11.73-21.18-26.13v-68.91c0-14.4,9.5-26.13,21.18-26.13h453.23c11.68,0,21.19,11.73,21.19,26.13v68.91c0,14.4-9.5,26.13-21.19,26.13ZM860.36,3605.7c-3.26,0-6.9,5.08-6.9,11.85v68.91c0,6.78,3.65,11.85,6.9,11.85h453.23c3.26,0,6.91-5.08,6.91-11.85v-68.91c0-6.78-3.65-11.85-6.91-11.85h-453.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1313.6,3711.43h-453.23c-11.03,0-20.01-11.19-20.01-24.96v-68.9c0-13.77,8.98-24.97,20.01-24.97h453.23c11.04,0,20.02,11.2,20.02,24.97v68.9c0,13.77-8.98,24.96-20.02,24.96ZM860.36,3604.53c-3.82,0-8.07,5.35-8.07,13.03v68.9c0,7.67,4.25,13.02,8.07,13.02h453.23c3.83,0,8.08-5.35,8.08-13.02v-68.9c0-7.68-4.25-13.03-8.08-13.03h-453.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1313.6,3718.56h-453.23c-14.97,0-27.15-14.4-27.15-32.1v-68.89c0-17.71,12.18-32.11,27.15-32.11h453.23c14.97,0,27.16,14.4,27.16,32.11v68.89c0,17.7-12.18,32.1-27.16,32.1ZM861.18,3611.67c-.64.71-1.75,2.72-1.75,5.9v68.89c0,3.65,1.47,5.76,2.01,6.12l452.15-.24c-.54-.12.93-2.23.93-5.88v-68.89c0-3.67-1.48-5.77-2.02-6.14l-451.34.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M909.79,3328c7.45.95,14.9,1.9,22.36,2.85,8.01,1.02,7.93-11.57,0-12.58-7.45-.95-14.9-1.9-22.36-2.85-8.01-1.02-7.93,11.57,0,12.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M942.68,3229.07v11.18c0,8.09,12.58,8.11,12.58,0v-11.18c0-8.09-12.58-8.11-12.58,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M986.19,3344.43c5.46-3.04,10.91-6.08,16.37-9.11,7.07-3.94.74-14.81-6.35-10.86-5.46,3.04-10.91,6.08-16.37,9.11-7.07,3.94-.74,14.81,6.35,10.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M921.59,3489.17c6.57-4.59,13.14-9.19,19.71-13.78,6.59-4.61.31-15.52-6.35-10.86-6.57,4.59-13.14,9.19-19.71,13.78-6.59,4.61-.31,15.52,6.35,10.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M874.43,3380.99c4.67,1.83,9.34,3.66,14.02,5.49,7.54,2.96,10.81-9.2,3.34-12.13-4.67-1.83-9.35-3.66-14.02-5.49-7.54-2.96-10.81,9.2-3.34,12.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M965.75,3439.4c3,.22,4.78,1.64,6.62,3.86,5.16,6.25,14.01-2.7,8.9-8.9-4.04-4.89-9.28-7.1-15.51-7.55-8.08-.58-8.04,12,0,12.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M993.34,3498.59c-1.36,8.8-.39,16.32,3.07,24.51,3.14,7.43,13.98,1.03,10.86-6.35-2.03-4.81-2.6-9.68-1.8-14.82,1.23-7.92-10.89-11.33-12.13-3.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1059.07,3500.9c3.71.99,7.42,1.98,11.14,2.97,7.83,2.09,11.17-10.04,3.34-12.13-3.71-.99-7.42-1.98-11.14-2.97-7.83-2.09-11.17,10.04-3.34,12.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1099.23,3377.23c-.65,7.16,2.04,13.67,7.52,18.3,6.15,5.19,15.09-3.66,8.9-8.9-3.21-2.71-4.21-5.28-3.84-9.4.73-8.06-11.85-8.01-12.58,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1083.27,3287.35c-3.66,4.98-4.3,10.07-3.25,16.04,1.4,7.96,13.53,4.59,12.13-3.34-.4-2.54.26-4.65,1.98-6.34,4.79-6.53-6.12-12.82-10.86-6.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1152.35,3324.12v11.18c0,8.09,12.58,8.11,12.58,0v-11.18c0-8.09-12.58-8.11-12.58,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1035.26,3304.39c2.79,1.86,5.59,3.73,8.39,5.59,6.76,4.5,13.06-6.39,6.35-10.86-2.79-1.86-5.59-3.73-8.39-5.59-6.76-4.5-13.06,6.39-6.35,10.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1056.3,3200.02c2.43,2.84,3.64,5.76,3.92,9.49.62,8.02,13.2,8.09,12.58,0-.55-7.21-2.91-12.9-7.61-18.38-5.27-6.16-14.14,2.77-8.9,8.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1088.05,3161.98v16.77c0,8.09,12.58,8.11,12.58,0v-16.77c0-8.09-12.58-8.11-12.58,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1165.83,3235.88c1.82,1.91,3.63,3.82,5.45,5.72,5.59,5.88,14.48-3.03,8.9-8.9-1.82-1.91-3.63-3.82-5.45-5.72-5.59-5.88-14.48,3.03-8.9,8.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1178.31,3160.92c5.57.32,11.15.64,16.72.96,8.09.46,8.06-12.12,0-12.58-5.57-.32-11.15-.64-16.72-.96-8.09-.46-8.06,12.12,0,12.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1196.12,3060.2c3.73,3.73,7.45,7.45,11.18,11.18,5.73,5.73,14.63-3.16,8.9-8.9-3.73-3.73-7.46-7.45-11.18-11.18-5.73-5.73-14.63,3.16-8.9,8.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1244.6,3027.79v19.57c0,8.09,12.58,8.11,12.58,0v-19.57c0-8.09-12.58-8.11-12.58,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1267.4,3145.52c1.85-2.8,3.7-5.61,5.55-8.42,4.47-6.78-6.42-13.09-10.86-6.35-1.85,2.8-3.7,5.61-5.55,8.42-4.47,6.78,6.42,13.09,10.86,6.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1224.75,3269.06c4.68-1.82,9.35-3.64,14.03-5.45,7.46-2.9,4.22-15.07-3.34-12.13-4.68,1.82-9.35,3.64-14.03,5.46-7.46,2.9-4.22,15.07,3.34,12.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1280.43,3251.51c4.65-.96,9.3-1.93,13.96-2.89,7.92-1.64,4.57-13.77-3.34-12.13-4.65.96-9.3,1.93-13.96,2.89-7.92,1.64-4.57,13.77,3.34,12.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1244.6,3310.14v2.8c0,8.09,12.58,8.11,12.58,0v-2.8c0-8.09-12.58-8.11-12.58,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1136.57,3502.75c2.79-1.86,5.59-3.73,8.39-5.59,6.71-4.47.41-15.37-6.35-10.86-2.8,1.86-5.59,3.73-8.39,5.59-6.71,4.47-.41,15.37,6.35,10.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1129.24,3549.12c5.01-4.8,10.37-7.59,17.11-9.17,7.88-1.84,4.54-13.98-3.34-12.13-8.75,2.04-16.19,6.2-22.67,12.4-5.86,5.61,3.05,14.5,8.9,8.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1077.42,3556.68c.95,1.86,1.89,3.71,2.84,5.57,3.68,7.21,14.54.86,10.86-6.35-.94-1.86-1.89-3.71-2.84-5.57-3.68-7.21-14.53-.86-10.86,6.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1029.52,3570.21c7.05,3.67,13.94,4.59,21.72,3.01,7.93-1.6,4.57-13.73-3.34-12.13-4.41.89-8.07.32-12.03-1.74-7.17-3.73-13.54,7.12-6.35,10.86h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1133.51,3450.9c8.37-1.05,16.74-2.1,25.12-3.15,7.93-.99,8.03-13.58,0-12.58-8.37,1.05-16.74,2.1-25.12,3.15-7.93.99-8.03,13.58,0,12.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2260.16,2899.63c135.4-122.4,270.79-244.81,406.19-367.21,20.06-18.14-9.67-47.72-29.65-29.65-135.4,122.4-270.79,244.81-406.19,367.21-20.06,18.14,9.67,47.72,29.65,29.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2719.21,3086.92c135.4-122.4,270.79-244.81,406.19-367.21,20.06-18.14-9.67-47.72-29.65-29.65-135.4,122.4-270.79,244.81-406.19,367.21-20.06,18.14,9.67,47.72,29.65,29.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2220.41,3225.66c283.78-276.71,567.55-553.43,851.32-830.14,19.35-18.87-10.31-48.51-29.65-29.65-283.78,276.71-567.55,553.43-851.32,830.14-19.35,18.87,10.31,48.51,29.65,29.65h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3503.33,
    y: 644.28,
    width: 18.25,
    height: 1171.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3586.82,1815.85c0,41.07-33.29,74.36-74.36,74.36s-74.36-33.29-74.36-74.36,33.29-74.36,74.36-74.36,74.36,33.29,74.36,74.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3513.5,2065.35c-1.23,0-25.51-.24-43.23-17.92-11.83-11.81-17.82-28.2-17.82-48.73,0-5.44,4.4-9.84,9.84-9.84s9.84,4.4,9.84,9.84c0,15.11,4.05,26.82,12.05,34.8,11.9,11.87,29.15,12.18,29.32,12.18,27.77,0,50.34-22.57,50.34-50.32s-22.57-50.32-50.32-50.32c-5.44,0-9.84-4.4-9.84-9.84v-54.68c0-5.44,4.4-9.84,9.84-9.84s9.84,4.4,9.84,9.84v45.52c33.96,4.8,60.16,34.05,60.16,69.31,0,38.6-31.4,70-70,70h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3122.96,2111.14c-3.78-.66-6.88-3.66-7.46-7.66-.73-4.98,2.71-9.62,7.7-10.36l402.55-59.3c4.99-.75,9.62,2.71,10.36,7.7.73,4.98-2.71,9.62-7.7,10.35l-402.55,59.3c-.99.15-1.96.13-2.89-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3895.66,2245.1c-.91-.16-1.8-.45-2.67-.9l-370.15-193.26c-4.47-2.33-6.2-7.84-3.87-12.31,2.33-4.47,7.83-6.22,12.31-3.87l370.15,193.26c4.47,2.33,6.2,7.84,3.87,12.31-1.88,3.61-5.84,5.43-9.65,4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3865.46,3017.86l-985.86-171.31c-51.65-8.97-86.25-58.13-77.28-109.78l98.64-567.64c8.97-51.65,58.13-86.25,109.78-77.28l985.86,171.31c51.65,8.97,86.25,58.13,77.27,109.78l-98.63,567.64c-8.98,51.65-58.13,86.25-109.78,77.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3878.91,3031.3c-6.29,0-12.66-.54-19.08-1.65l-978.91-170.09c-29.22-5.08-54.72-21.24-71.79-45.49-17.07-24.26-23.67-53.7-18.59-82.92l97.43-560.7c10.48-60.31,68.09-100.84,128.39-90.39l978.91,170.11c29.22,5.07,54.72,21.22,71.79,45.48,17.07,24.24,23.67,53.69,18.61,82.91l-97.43,560.7c-9.39,53.92-56.4,92.02-109.34,92.04ZM2997.31,2103.57c-40.96,0-77.31,29.48-84.56,71.18l-97.43,560.7c-3.92,22.6,1.18,45.37,14.38,64.13,13.2,18.76,32.92,31.25,55.52,35.18l978.92,170.08c46.59,8.17,91.17-23.24,99.3-69.89l97.43-560.7c3.93-22.6-1.18-45.37-14.38-64.13-13.2-18.76-32.92-31.25-55.51-35.18l-978.93-170.11c-4.95-.86-9.88-1.27-14.74-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3858.07,2956.39l-950.77-165.21c-33-5.73-55.11-37.14-49.37-70.14l90.07-518.35c5.74-33,37.14-55.11,70.14-49.37l950.77,165.21c33,5.73,55.11,37.14,49.37,70.14l-90.07,518.35c-5.74,33-37.14,55.11-70.14,49.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3866.77,2969.53c-4.34,0-8.71-.38-13.07-1.13l-946.34-164.45c-19.86-3.45-37.19-14.43-48.8-30.91-11.61-16.49-16.1-36.51-12.65-56.37l89.3-513.92c7.12-41,46.22-68.61,87.29-61.44l946.33,164.44c41.01,7.12,68.58,46.27,61.46,87.28l-89.3,513.91c-3.45,19.87-14.43,37.2-30.93,48.81-12.86,9.06-27.88,13.77-43.29,13.77ZM3857.99,2943.61c13.24,2.29,26.6-.7,37.59-8.42,10.99-7.73,18.31-19.29,20.61-32.53l89.3-513.93c4.75-27.33-13.63-53.44-40.95-58.19l-946.35-164.44c-27.28-4.72-53.44,13.63-58.2,40.97l-89.3,513.92c-2.3,13.24.7,26.59,8.44,37.58,7.73,10.99,19.29,18.31,32.53,20.61l946.32,164.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "3407.03 2878.02 3653.05 2652.55 3789.2 2944.43 3407.03 2878.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3803.59,2955.43l-414.81-72.07,267.03-244.72,147.78,316.79ZM3425.28,2872.68l349.52,60.74-124.52-266.96-225,206.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "2920.58 2793.49 3356.73 2393.75 3598.12 2911.22 2920.58 2793.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3612.52,2922.23l-710.19-123.4,457.16-418.98,253.02,542.38ZM2938.81,2788.15l644.91,112.06-229.76-492.55-415.15,380.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3875.36,2469.54c-5.77,33.19-37.35,55.42-70.53,49.65-33.19-5.77-55.42-37.34-49.65-70.53,5.77-33.19,37.35-55.42,70.53-49.65,33.19,5.77,55.42,37.35,49.65,70.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3815.4,2528.5c-3.98,0-8.01-.34-12.02-1.04-37.69-6.55-63.01-42.54-56.46-80.23,3.16-18.26,13.25-34.19,28.42-44.87,15.14-10.66,33.51-14.8,51.81-11.62,18.25,3.17,34.18,13.27,44.85,28.42,10.66,15.15,14.79,33.55,11.61,51.81-3.16,18.26-13.25,34.19-28.42,44.87-11.81,8.32-25.62,12.66-39.79,12.66ZM3815.16,2406.47c-10.74,0-21.21,3.29-30.17,9.61-11.5,8.09-19.15,20.17-21.56,34.01-2.39,13.85.74,27.8,8.81,39.29,8.09,11.49,20.18,19.14,34.02,21.55,13.76,2.4,27.78-.72,39.28-8.81,11.5-8.09,19.15-20.17,21.56-34.01h0c4.96-28.58-14.25-55.87-42.83-60.83-3.03-.53-6.08-.79-9.11-.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3352.39,
    y: 604.86,
    width: 914.23,
    height: 100.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5061.13,2684.83h-303.5V1.34h303.5v2683.5ZM4787.64,2654.81h243.46V31.35h-243.46v2623.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5057.32,295.89h-295.89V0h295.89v295.89ZM4791.85,265.47h235.06V30.42h-235.06v235.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4894.17,
    y: -39.78,
    width: 30.42,
    height: 375.44,
    transform: "translate(1333.3 3514.77) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4721.66,
    y: 132.74,
    width: 375.44,
    height: 30.42,
    transform: "translate(1333.31 3514.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5057.32,561.36h-295.89v-295.89h295.89v295.89ZM4791.85,530.95h235.06v-235.06h-235.06v235.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4894.17,
    y: 225.7,
    width: 30.42,
    height: 375.44,
    transform: "translate(1145.59 3592.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4721.66,
    y: 398.21,
    width: 375.44,
    height: 30.42,
    transform: "translate(1145.59 3592.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5057.32,826.84h-295.89v-295.89h295.89v295.89ZM4791.85,796.43h235.06v-235.06h-235.06v235.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4894.17,
    y: 491.17,
    width: 30.42,
    height: 375.44,
    transform: "translate(957.85 3670.27) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4721.66,
    y: 663.68,
    width: 375.44,
    height: 30.42,
    transform: "translate(957.99 3670.45) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5057.32,1092.32h-295.89v-295.89h295.89v295.89ZM4791.85,1061.9h235.06v-235.06h-235.06v235.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4894.17,
    y: 756.65,
    width: 30.42,
    height: 375.44,
    transform: "translate(770.14 3748.04) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4721.66,
    y: 929.16,
    width: 375.44,
    height: 30.42,
    transform: "translate(770.15 3748.05) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5057.32,1357.79h-295.89v-295.89h295.89v295.89ZM4791.85,1327.37h235.06v-235.06h-235.06v235.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4894.17,
    y: 1022.12,
    width: 30.42,
    height: 375.44,
    transform: "translate(582.43 3825.81) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4721.66,
    y: 1194.64,
    width: 375.44,
    height: 30.42,
    transform: "translate(582.53 3825.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5057.32,1623.27h-295.89v-295.89h295.89v295.89ZM4791.85,1592.85h235.06v-235.06h-235.06v235.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4894.17,
    y: 1287.6,
    width: 30.42,
    height: 375.44,
    transform: "translate(394.7 3903.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4721.66,
    y: 1460.11,
    width: 375.44,
    height: 30.42,
    transform: "translate(394.81 3903.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5057.32,1888.74h-295.89v-295.89h295.89v295.89ZM4791.85,1858.33h235.06v-235.06h-235.06v235.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4894.17,
    y: 1553.08,
    width: 30.42,
    height: 375.44,
    transform: "translate(206.99 3981.32) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4721.66,
    y: 1725.59,
    width: 375.44,
    height: 30.42,
    transform: "translate(207.08 3981.5) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5057.32,2154.21h-295.89v-295.89h295.89v295.89ZM4791.85,2123.8h235.06v-235.06h-235.06v235.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4894.17,
    y: 1818.55,
    width: 30.42,
    height: 375.44,
    transform: "translate(19.27 4059.06) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4721.66,
    y: 1991.06,
    width: 375.44,
    height: 30.42,
    transform: "translate(19.35 4059.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5057.32,2419.69h-295.89v-295.89h295.89v295.89ZM4791.85,2389.27h235.06v-235.06h-235.06v235.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4894.17,
    y: 2084.02,
    width: 30.42,
    height: 375.44,
    transform: "translate(-168.44 4136.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4721.66,
    y: 2256.54,
    width: 375.44,
    height: 30.42,
    transform: "translate(-168.37 4137.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5057.32,2685.16h-295.89v-295.89h295.89v295.89ZM4791.85,2654.75h235.06v-235.06h-235.06v235.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5031.36 2680.71 4765.88 2415.23 4787.39 2393.73 5052.87 2659.2 5031.36 2680.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "4787.39 2680.71 4765.88 2659.2 5031.36 2393.73 5052.87 2415.23 4787.39 2680.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5585.57,557.36h-295.89v-295.89h295.89v295.89ZM5320.09,526.95h235.06v-235.06h-235.06v235.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5249.9,
    y: 394.21,
    width: 375.44,
    height: 30.42,
    transform: "translate(1303.81 3965.67) rotate(-45.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5422.41,
    y: 221.7,
    width: 30.42,
    height: 375.44,
    transform: "translate(1303.13 3964.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5320.09,557.36h-295.89v-295.89h295.89v295.89ZM5054.62,526.95h235.06v-235.06h-235.06v235.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4984.43,
    y: 394.21,
    width: 375.44,
    height: 30.42,
    transform: "translate(1226.02 3777.92) rotate(-45.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5156.94,
    y: 221.7,
    width: 30.42,
    height: 375.44,
    transform: "translate(1225.36 3777.15) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5054.62,557.36h-295.89v-295.89h295.89v295.89ZM4789.14,526.95h235.06v-235.06h-235.06v235.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4789.14,557.36h-295.89v-295.89h295.89v295.89ZM4523.67,526.95h235.06v-235.06h-235.06v235.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4453.48,
    y: 394.21,
    width: 375.44,
    height: 30.41,
    transform: "translate(1069.87 3401.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4625.99,
    y: 221.7,
    width: 30.41,
    height: 375.44,
    transform: "translate(1069.85 3401.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4523.67,557.36h-295.89v-295.89h295.89v295.89ZM4258.19,526.95h235.06v-235.06h-235.06v235.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4188,
    y: 394.21,
    width: 375.44,
    height: 30.41,
    transform: "translate(992.11 3214.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4360.51,
    y: 221.7,
    width: 30.41,
    height: 375.44,
    transform: "translate(992.12 3214.03) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4258.19,557.36h-295.89v-295.89h295.89v295.89ZM3992.71,526.95h235.06v-235.06h-235.06v235.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3977.51,557.36h-265.48c-6.15,0-11.7-3.7-14.05-9.39-2.35-5.68-1.05-12.22,3.3-16.57l265.47-265.48,21.51,21.51-239.51,239.52h222.46l261.02-261.02,21.51,21.51-265.47,265.48c-2.85,2.85-6.72,4.46-10.75,4.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4095.04,
    y: 221.7,
    width: 30.41,
    height: 375.44,
    transform: "translate(914.35 3026.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5061.78,2980.72h-304.15v-295.89h304.15v295.89ZM4788.89,2950.31h241.62v-235.06h-241.62v235.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5035.09 2976.27 4762.21 2710.79 4784.31 2689.29 5057.2 2954.76 5035.09 2976.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "4784.31 2976.27 4762.21 2954.76 5035.09 2689.29 5057.2 2710.79 4784.31 2976.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5061.78,4042.62h-304.15v-295.89h304.15v295.89ZM4788.89,4012.2h241.62v-235.06h-241.62v235.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5035.09 4038.17 4762.21 3772.69 4784.31 3751.18 5057.2 4016.65 5035.09 4038.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "4784.31 4038.17 4762.21 4016.65 5035.09 3751.18 5057.2 3772.69 4784.31 4038.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5061.78,3221.04h-304.15v-295.89h304.15v295.89ZM4788.89,3190.62h241.62v-235.06h-241.62v235.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5035.09 3216.58 4762.21 2951.11 4784.31 2929.6 5057.2 3195.07 5035.09 3216.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "4784.31 3216.58 4762.21 3195.07 5035.09 2929.6 5057.2 2951.11 4784.31 3216.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5061.78,3486.51h-304.15v-295.89h304.15v295.89ZM4788.89,3456.09h241.62v-235.06h-241.62v235.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5035.09 3482.06 4762.21 3216.58 4784.31 3195.07 5057.2 3460.54 5035.09 3482.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "4784.31 3482.06 4762.21 3460.54 5035.09 3195.07 5057.2 3216.58 4784.31 3482.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5061.78,3751.98h-304.15v-295.89h304.15v295.89ZM4788.89,3721.57h241.62v-235.06h-241.62v235.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5035.09 3747.53 4762.21 3482.06 4784.31 3460.55 5057.2 3726.02 5035.09 3747.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "4784.31 3747.53 4762.21 3726.02 5035.09 3460.55 5057.2 3482.06 4784.31 3747.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1667.42,1610.13c32.38,0,32.43-50.32,0-50.32s-32.43,50.32,0,50.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M4395.85,1084.57c32.38,0,32.43-50.32,0-50.32s-32.43,50.32,0,50.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M5525.23,2884.89h11.18c13.16,0,25.77-11.57,25.16-25.16-.61-13.63-11.06-25.16-25.16-25.16h-11.18c-13.16,0-25.77,11.57-25.16,25.16.61,13.63,11.05,25.16,25.16,25.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M672.22,3253.9c32.38,0,32.43-50.32,0-50.32s-32.43,50.32,0,50.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M3076.36,838.57c32.38,0,32.43-50.32,0-50.32s-32.43,50.32,0,50.32h0Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.f0a37bad9ca5ecd29d232fcc57913d35.svg";
export { ForwardRef as ReactComponent };